import {
    GET_SAVE_ADMIN_TASK_VALUE,
    SET_SAVE_ADMIN_TASK_VALUE,
    SET_SAVED_STATUS,
    GET_SAVE_ASSET_ADMIN_TASK_VALUE,
    SET_SAVE_ASSET_ADMIN_TASK_VALUE,
    GET_SAVE_AFE_ADMIN_TASK_VALUE,
    SET_SAVE_AFE_ADMIN_TASK_VALUE
} from "./AdminTaskType"

const getSaveAdminTaskvalue = (adminTaskSaveValue: any) => ({
    type : GET_SAVE_ADMIN_TASK_VALUE,
    adminTaskSaveValue
})

const setSaveAdminTaskvalue = (SavedAdminTaskValue: any) => ({
    type : SET_SAVE_ADMIN_TASK_VALUE,
    SavedAdminTaskValue : SavedAdminTaskValue
})

const setSavedStatus = (savedStatus: any) => ({
    type : SET_SAVED_STATUS,
    savedStatus : savedStatus
})

const getSaveAssetAdminTaskvalue = (adminAssetTaskSaveValue: any) => ({
    type : GET_SAVE_ASSET_ADMIN_TASK_VALUE,
    adminAssetTaskSaveValue
})

const setSaveAssetAdminTaskvalue = (SavedAssetAdminTaskValue: any) => ({
    type : SET_SAVE_ASSET_ADMIN_TASK_VALUE,
    SavedAssetAdminTaskValue : SavedAssetAdminTaskValue
})

const getSaveAfeAdminTaskvalue = (adminAfeTaskSaveValue: any) => ({
    type : GET_SAVE_AFE_ADMIN_TASK_VALUE,
    adminAfeTaskSaveValue
})

const setSaveAfeAdminTaskvalue = (SavedAfeAdminTaskValue: any) => ({
    type : SET_SAVE_AFE_ADMIN_TASK_VALUE,
    SavedAfeAdminTaskValue : SavedAfeAdminTaskValue
})

export {
    getSaveAdminTaskvalue,
    setSaveAdminTaskvalue,
    setSavedStatus,
    getSaveAssetAdminTaskvalue,
    setSaveAssetAdminTaskvalue,
    getSaveAfeAdminTaskvalue,
    setSaveAfeAdminTaskvalue
}